import { render } from "./AllCustomers.vue?vue&type=template&id=61370dea&scoped=true"
import script from "./AllCustomers.vue?vue&type=script&lang=js"
export * from "./AllCustomers.vue?vue&type=script&lang=js"

import "./AllCustomers.vue?vue&type=style&index=0&id=61370dea&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61370dea"]])

export default __exports__